module.exports = function () {
    $(document).ready(function () {

        var helper = require('./helper');

        /** MUST BE TOGGLE BY ID, NOT BY CLASS */
        // $('div[id^="room-information-"]').click(function () {
        //     var id = this.id.substring(17, this.id.length);
        //     $('#room-information-in-' + id).toggle();
        // });

        /** TODO: Determine modal where the error has been appeared */
        if ($.find('.has-error').length != 0) {
            $('#add-room').modal('show');
        }

        /** Handle click Assign button, then copy and paste id of room */
        $('a[id^="assign-button-"]').click(function () {
            var id = this.id.substring(14, this.id.length);
            $('#modal-room-id-field').val($('#room-id-' + id).text())
        });

    });
}();
